import React from 'react'


export const Mascota = ({mascota}) => {

  const orientation = mascota.reflected?2:1;
  const style = mascota.reflected?{right:`${mascota.x}%`}:{left:`${mascota.x}%`}
  
  return (
    <div className={`mascota${orientation}`} style={style} id="mascota">
        <img src={mascota.image} />
    </div>
  )
}
